export default {
    state: {
        perPage : [10, 20, 25, 50, 75, 100]
    }
}